import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { MonitoreoRelacionFincaCultivoPlagaService } from "../../../../generated/grpc/configuracion_monitoreo_pb";
import { grpcMonitoreoRelacionFincaCultivoPlagaDatabase } from "../database/GrpcMonitoreoRelacionFincaCultivoPlagaDatabase";
import { MonitoreoRelacionFincaCultivoPlagaRequest } from "../request/MonitoreoRelacionFincaCultivoPlagaRequest";
import { MonitoreoRelacionFincaCultivoPlagaResponse } from "../response/MonitoreoRelacionFincaCultivoPlagaResponse";
import { toMonitoreoRelacionFincaCultivoPlagaResponse } from "./MonitoreoRelacionFincaCultivoPlagaGrpcService";

/** Variante gRPC-Web de `MonitoreoRelacionFincaCultivoPlagaSaveService` (ver
 *  ese archivo): habilita (alta o reactivación) una plaga en un cultivo de
 *  una finca. No invalida ningún cooldown: `putOneAsync` ya deja la relación
 *  correcta en `GrpcMonitoreoRelacionFincaCultivoPlagaDatabase`. */
export class MonitoreoRelacionFincaCultivoPlagaSaveGrpcService
  implements
    ISaveService<
      MonitoreoRelacionFincaCultivoPlagaRequest,
      MonitoreoRelacionFincaCultivoPlagaResponse
    >
{
  async saveAsync(
    request: MonitoreoRelacionFincaCultivoPlagaRequest,
  ): Promise<MonitoreoRelacionFincaCultivoPlagaResponse> {
    const client = createClient(
      MonitoreoRelacionFincaCultivoPlagaService,
      grpcTransportProvider.get(),
    );

    let saved;
    try {
      saved = await client.guardar({
        fincaId: request.fincaId,
        cultivoId: request.cultivoId,
        plagaEnfermedadId: request.plagaEnfermedadId,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcMonitoreoRelacionFincaCultivoPlagaDatabase.putOneAsync(saved);
    return toMonitoreoRelacionFincaCultivoPlagaResponse(saved);
  }
}

/** Instancia única del servicio gRPC de alta de relaciones. */
export const monitoreoRelacionFincaCultivoPlagaSaveGrpcService =
  new MonitoreoRelacionFincaCultivoPlagaSaveGrpcService();
